module.exports = __webpack_public_path__ + "img/itsmlogo.png";